import { useEffect } from "react";
import { Typography, Box, Button, Grid, Hidden, Card, CardContent } from "@material-ui/core";
import { QuoteLineItem } from "../../../api/Quote/QuoteLineItem";
import { Quote } from "../../../api/Quote/Quote";
import { categoryDescription, categoryTitle, quoteImage } from "../../../app/utils";
import QuoteAddonWizardCategory from "./QuoteAddonWizardCategory";
import QuoteAddonWizardAddonsSelected from "./QuoteAddonWizardAddonsSelected";
import React from "react";
import { QuoteHr } from "../../quotePage/components/QuoteHr";
import QuoteAddonWizardRightPreview from "./QuoteAddonWizardRightPreview";
import { ProductSubscription } from "../../../api/Product/ProductSubscriptionApi";
import { EventSlot } from "../../../api/EventSlot/EventSlot";
import QuoteRightInfo from "../../quotePage/components/QuoteRightInfo";

interface Props {
  onNext: () => void;
  quote: Quote;
  activeStep: number;
  steps: string[];
  subscriptions: ProductSubscription[] | null;
  onAddAddon: (addon: QuoteLineItem) => void;
  onChangeQuantity: (addon: QuoteLineItem, quantity: number) => void;
  onRemoveAddon: (addon: QuoteLineItem) => void;
  onInfoDialogOpen: (addon: QuoteLineItem) => void;
  onAddSubscription: (subscription: ProductSubscription) => void;
  btnNextText: () => string;
  eventSlots: EventSlot[] | null;
  onLockEventSlot: (eventSlot: EventSlot) => Promise<boolean>;
  selectedEventSlot: EventSlot | null;
  onApplyPromoCode: (promoCode: string) => void;
  onDeletePromoCode: (quoteDeductionId: string) => void;
}

const QuoteAddonWizardContent = ({
  quote,
  activeStep,
  steps,
  subscriptions,
  onAddAddon,
  onNext,
  onInfoDialogOpen,
  onChangeQuantity,
  onRemoveAddon,
  onAddSubscription,
  btnNextText,
  eventSlots,
  onLockEventSlot,
  selectedEventSlot,
  onApplyPromoCode,
  onDeletePromoCode
}: Props) => {
  const [activeCategory, setActiveCategory] = React.useState("");

  useEffect(() => {
    setActiveCategory(steps[activeStep]);
  }, [activeStep, steps]);

  const stepsSection = steps.map((v, i) => {
    return (
      <QuoteAddonWizardCategory
        quote={quote}
        key={`category${i}`}
        activeStep={activeStep}
        onAddAddon={onAddAddon}
        onInfoDialogOpen={onInfoDialogOpen}
        onChangeQuantity={onChangeQuantity}
        step={i}
        category={v}
        subscriptions={subscriptions}
        onAddSubscription={onAddSubscription}
        eventSlots={eventSlots}
        onLockEventSlot={onLockEventSlot}
        selectedEventSlot={selectedEventSlot}
        onNext={onNext}
      />
    );
  });

  return (
    <Grid container spacing={3} justifyContent="center">
      <Grid item md={12} xs={12}>
        <Box textAlign="center" p={3}>
          <Typography variant="h2">{categoryTitle(quote.type, activeCategory)}</Typography>
          <Typography variant="body1">{categoryDescription(activeCategory)}</Typography>
        </Box>
      </Grid>
      <Grid item md={7} xs={12}>
        {stepsSection}
        <Hidden lgUp>
          <Box m={3}>
            <Button fullWidth onClick={onNext} variant="contained" color="secondary">
              {btnNextText()}
            </Button>
          </Box>
        </Hidden>
      </Grid>
      <Hidden mdDown>
        <Grid item md={5}>
          <Card square>
            <CardContent>
              <QuoteRightInfo
                selectedEventSlot={selectedEventSlot}
                quote={quote}
                onApplyPromoCode={onApplyPromoCode}
                onDeletePromoCode={onDeletePromoCode}
              />
              <Box mt={3} mb={3} mx="auto" width={0.7}>
                <Button fullWidth onClick={onNext} variant="contained" color="secondary">
                  {btnNextText()}
                </Button>
              </Box>
              <QuoteHr />
              <Box mt={3} mb={3}>
                <QuoteAddonWizardRightPreview
                  title="Your packages includes"
                  image={quoteImage(quote)}
                  name={quote.title}
                />
              </Box>
              <QuoteHr />
              <Box mt={3}>
                <QuoteAddonWizardAddonsSelected onRemoveAddon={onRemoveAddon} addons={quote.addons} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Hidden>
    </Grid>
  );
};

export default QuoteAddonWizardContent;
